import { useNavigate, useLocation } from "react-router-dom";
import { useCallback, useState, useEffect } from "react";
import useURLQuery from "./useURLQuery";

const useTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlQuery = useURLQuery();

  // Get tab from URL or default to 0
  const [currentTab, setCurrentTab] = useState<number>(
    parseInt(urlQuery.get("tabpanel") || "0", 10)
  );

  // Update tab state when URL changes
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const tabFromUrl = parseInt(query.get("tabpanel") || "0", 10);

    // Only update if different to avoid unnecessary rerenders
    if (tabFromUrl !== currentTab) {
      setCurrentTab(tabFromUrl);
    }
  }, [location.search, currentTab]);

  const handleChangeTab = useCallback(
    (event: React.ChangeEvent<any>, newValue: number) => {
      setCurrentTab(newValue);
      navigate(`${window.location.pathname}?tabpanel=${newValue}`);
    },
    [navigate]
  );

  return {
    currentTab,
    handleChangeTab,
  };
};

export default useTabs;
